import { Component, Input, OnInit } from '@angular/core';
import { EndpointService } from '@app/endpoint/endpoint.service';
import { TestCaseService } from '@app/testcase/testcase.service';
import { TestsuiteService } from '@app/testsuite/testsuite.service';
import { UserService } from '@app/user/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-shared-associated-details',
  templateUrl: './shared-associated-details.component.html',
  styleUrls: ['./shared-associated-details.component.less']
})
export class SharedAssociatedDetailsComponent implements OnInit {
  @Input() type;
  @Input() endPointId: any;
  @Input() testCaseId: any;
  @Input() testSuiteId: any;
  associatedData : any = [];

  constructor(private userService: UserService, private endpointService : EndpointService, private testcaseServices : TestCaseService,
    private testsuiteService : TestsuiteService,private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if(this.endPointId !== null && this.endPointId !== undefined) {
      this.getTestCases();
    }
    if(this.testCaseId !== null && this.testCaseId !== undefined) {
      this.getTestSuite();
    }
    if(this.testSuiteId !== null && this.testSuiteId !== undefined) {
      this.getMasterSuite();
    }
  }

  getTestCases(): void {
    this.associatedData = [];
    let searchParams = {};
    this.endpointService.getAssociatedTestcases(this.endPointId, searchParams).pipe().subscribe(data => {
      if (data.code == 200) {
        this.associatedData = data.response.testCases;
      } else {
        this.associatedData = [];
      }
    });
  }

  getTestSuite(): void {
    this.associatedData = [];
    let searchParams = {};
    this.testcaseServices.getAssociatedTestsuites(this.testCaseId, searchParams).pipe().subscribe(data => {
      if (data.code == 200) {
        this.associatedData = data.response.testSuites;
      } else {
        this.associatedData = [];
      }
    });
  }

  getMasterSuite(): void {
    this.associatedData = [];
    let searchParams = {};
    this.testsuiteService.getAssociatedMastersuites(this.testSuiteId, searchParams).pipe().subscribe(data => {
      if (data.code == 200) {
        this.associatedData = data.response.masterSuites;
      } else {
        this.associatedData = [];
      }
    });
  }

  close() {
    this.activeModal.close();
  }

}
